$(document).ready(function() {
    window.ajax_cart = !0;
    jQuery(window).load(function() {
        jQuery(".ttloader").fadeOut("slow")
    })
});


//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//==================== account toggle ====================//
$(document).ready(function(){
	$(".user-background").click(function(){
	$(".tm_header-dropdown .my-account").slideToggle(800);
	$('.tm_header-dropdown').toggleClass('active'); 
	});
});


//==================== cart toggle ====================//
$(document).ready(function(){
	$(".cart-text_block").click(function(){
	$(".site-header__cart .cart-content.block").slideToggle(800);
	$('.site-header__cart').toggleClass('active'); 
	});
});


//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function() {
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function() {
            $($(this).attr('href')).hide()
        });
        $(this).find('a').click(function(e) {
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return !1
        })
    })
});


//=============================== Reviews Slider ==================================//
  $('.quotes-slider.owl-carousel').owlCarousel({
    loop: !1,
    margin: 0,
    nav: !1,
    dots: !1,
    autoplay: !0,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

//========================blog list slider==========================// 
 $('#blog_slider.owl-carousel').owlCarousel({
    loop: !0,
    nav: !1,
    dots: !1,
    autoplay: !1,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 2
        },
        1000: {
            items: 3
        }
    }
})

//======================Featured collection product slider======================//

$('.slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target).find('.owl-item').removeClass('last').eq(event.item.index + event.page.size - 1).addClass('last')
}).owlCarousel({
    loop: !0,
    nav: !0,
    dots: !1,
    rows: 2,
    responsive: {
        0: {
            items: 2
        },
        551: {
            items: 3
        },
        750: {
            items: 5
        },
        1271: {
            items: 5
        }
    }
})


//============================ Image Overlay block ===============================//
$( ".collection.overlay-collection_top" ).insertAfter( $( ".hero-top.hero__container" ) );
$(".collection.overlay-collection_top").addClass( "page-width" );  

$( ".collection.overlay-collection_bottom" ).insertAfter( $( ".hero-bottom.hero__container" ) );
$(".collection.overlay-collection_bottom").addClass( "page-width" );  


/*====================== overlay collection product slider======================*/
$(document).ready(function() {
    var overlaycollectionsliders = $("#overlay-collection_top_products_slider");
        overlaycollectionsliders.owlCarousel({
            items : 1 , //10 items above 1000px browser width
            itemsDesktop : [1280,1], //5 items between 1000px and 901px
            itemsDesktopSmall : [990,1], // betweem 900px and 601px
            itemsTablet: [749,1], //2 items between 600 and 0
            itemsMobile : [479,1], // itemsMobile disabled - inherit from itemsTablet option
          	autoPlay: true
        });
        $(".overlay-collection_top_next").click(function(){
            overlaycollectionsliders.trigger('owl.next'); 
        });
        $(".overlay-collection_top_prev").click(function(){
            overlaycollectionsliders.trigger('owl.prev');
        });
});


$(document).ready(function() {
    var overlaycollectionbottomsliders = $("#overlay-collection_bottom_products_slider");
        overlaycollectionbottomsliders.owlCarousel({
            items : 1 , //10 items above 1000px browser width
            itemsDesktop : [1280,1], //5 items between 1000px and 901px
            itemsDesktopSmall : [990,1], // betweem 900px and 601px
            itemsTablet: [749,1], //2 items between 600 and 0
            itemsMobile : [479,1], // itemsMobile disabled - inherit from itemsTablet option
          	autoPlay: true
        });
        $(".overlay-collection_bottom_next").click(function(){
            overlaycollectionbottomsliders.trigger('owl.next'); 
        });
        $(".overlay-collection_bottom_prev").click(function(){
            overlaycollectionbottomsliders.trigger('owl.prev');
        });
});


/*=====================  More site navigation =======================*/
function more() {
  if ($(window).width() > 1600){
    var max_elem = 7;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 5;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 4;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more()
});


// ================================ Product tab slider ==================================//

$('.product-slider .tab-slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target).find('.owl-item').removeClass('last').eq(event.item.index + event.page.size - 1).addClass('last')
}).owlCarousel({
    loop: !0,
    nav: !0,
    dots: !1,
    rows: 2,
    responsive: {
        0: {
            items: 2
        },
        480: {
            items: 3
        },
        990: {
            items: 4
        },
        1270: {
            items: 5
        }
    }
})

// ================================ Related Product slider ==================================//

$('.related.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target).find('.owl-item').removeClass('last').eq(event.item.index + event.page.size - 1).addClass('last')
}).owlCarousel({
    loop: !0,
    //margin: 10,
    nav: !0,
    dots: !1,
    responsive: {
        0: {
            items: 2
        },
        551: {
            items: 3
        },
        990: {
            items: 4
        },
        1270: {
            items: 5
        }
    }
})
$('.related.slider.owl-carousel').find('.owl-nav').removeClass('disabled');

//========================brand list slider==========================//
$('#brand-slider.owl-carousel').owlCarousel({
    loop: !0,
    margin: 10,
    nav: !1,
    dots: !1,
    autoplay: !0,
    responsive: {
        0: {
            items: 1
        },
        551: {
            items: 3
        },
        750: {
            items: 4
        },
        990: {
            items: 5
        },
        1270: {
            items: 6
        }
    }
})

//======================== tm__mainbanner_cms list slider==========================//
$('.tm__mainbanner_cms--wrapper .owl-carousel').owlCarousel({
    loop: !0,
    nav: !1,
    dots: !1,
  	center: true,
    autoplay: !0,
    responsive: {
        0: {
            items: 3
        },
        551: {
            items: 3
        },
        750: {
            items: 3
        },
        1000: {
            items: 3
        }
    }
})

// $(document).ready(function() {
  
// checkClasses();
//     $('.tm__mainbanner_cms--wrapper .owl-carousel').on('translated.owl.carousel', function(event) {
//         checkClasses();
//     });

//     function checkClasses(){
//         var total = $('.tm__mainbanner_cms--wrapper .owl-carousel .owl-stage .owl-item.active').length;

//         $('.tm__mainbanner_cms--wrapper .owl-carousel .owl-stage .owl-item').removeClass('firstActiveItem lastActiveItem');

//         $('.tm__mainbanner_cms--wrapper .owl-carousel .owl-stage .owl-item.active').each(function(index){
//             if (index === 0) {
//                 // this is the first one
//                 $(this).addClass('firstActiveItem');
//             }
//             if (index === total - 1 && total>1) {
//                 // this is the last one
//                 $(this).addClass('lastActiveItem');
//             }
//         });
//     }
// });

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 190; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
            $($(this).attr('href')).hide()
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading").addClass('toggle');
    $(".side-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading").removeClass('toggle');
    $(".side-bar h3.box-heading").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);


/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);

//======================mobile menu toogle======================//

$(document).ready(function() {
    $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
    $('#MobileNav .mobile_togglecolumn').click(function() {
        $(this).parent().toggleClass('active')
    });
    $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
    $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function() {
        $(this).parent().toggleClass('active')
    })
});

/*================== sidebar category-box ===================*/
function mobileToggleMenu10(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu10);

function mobileToggleMenu11(){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
}
$(document).ready(mobileToggleMenu11);


//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 990)
	{
		$('.main-content .page-width.contents .side-bar').insertAfter('.main-content .page-width.contents .main-container');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });

$(document).ready(function() {
    $(".currency-block").click(function() {
        $(".currency .currency-menu").slideToggle(500);
        $('.currency').toggleClass('active')
    })
});

 